// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortcut-actions.collapsed {
	display: none;
}
.shortcuts-toggle {
	width: 2.5rem;
}
.shortcuts-section-icon {
	width: 1.5rem;
}
.shortcuts-section.collapsed {
	display: none;
}
.UserView .shortcuts-toggle.collapsed {
	color: var(--bs-gray-300)
}
.UserView .circle {
	width: 2rem;
    height: 2rem;
    border-radius: 50%;
}
.UserView .menu-actions .account-name {
	font-size: 1.25rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
